// @ts-nocheck bd2f27f4
import createWeeklyTimetableWidget from './createWeeklyTimetableWidget';

export default ({ editorAPI }) =>
  createWeeklyTimetableWidget({
    editorAPI,
  });
